function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import { withMedia } from 'react-media-query-hoc';
import { Select } from '@domain-group/fe-blueprint-ui/select';
import { PinIcon } from '@domain-group/fe-co-icon';
import { LocalityCommonRegion, LocalityType } from '@domain-group/fe-allhomes-library';
import { Filters } from '@domain-group/fe-allhomes-search-api';
import Dropdown from '@domain-group/fe-co-allhomes-dropdown';
import localityPropTypes, { regionGroupPropTypes } from '../proptypes/locality';
import Selector from './selector/selector';
import * as styles from './region-selector.style';
import * as dropdownStyles from './dropdown.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var localitySlugToFilter = function localitySlugToFilter() {
  var localitySlug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _localitySlug$split = localitySlug.split('-'),
    _localitySlug$split2 = _slicedToArray(_localitySlug$split, 2),
    type = _localitySlug$split2[0],
    id = _localitySlug$split2[1];
  switch (type) {
    case LocalityType.REGION.type:
    case LocalityType.DISTRICT.type:
    case LocalityType.DIVISION.type:
      return [{
        id,
        type
      }];
    default:
      return undefined;
  }
};
var localityToSlug = function localityToSlug() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    type = _ref.type,
    id = _ref.id;
  return type && id ? "".concat(type, "-").concat(id) : undefined;
};
var getLocalityName = function getLocalityName() {
  var locality = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = locality.name || '';
  if (locality.type === LocalityType.REGION.type && locality.id === LocalityCommonRegion.CANBERRA.regionId) {
    name = 'All Canberra';
  }
  var state = get(locality, 'metaData.state');
  if (state) {
    name += ", ".concat(state);
  }
  return name.trim();
};
var regionGroupToOptions = function regionGroupToOptions() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    region = _ref2.region,
    _ref2$districts = _ref2.districts,
    districts = _ref2$districts === void 0 ? [] : _ref2$districts,
    _ref2$nearbyDistricts = _ref2.nearbyDistricts,
    nearbyDistricts = _ref2$nearbyDistricts === void 0 ? [] : _ref2$nearbyDistricts;
  var extraOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = [];
  if (region) {
    options.push({
      label: extraOpts.addState ? getLocalityName(region) : region.name,
      value: localityToSlug(region)
    });
  }
  districts.forEach(district => {
    options.push({
      label: extraOpts.addState ? getLocalityName(district) : district.name,
      value: localityToSlug(district)
    });
  });
  if (nearbyDistricts.length) {
    options.push(_objectSpread({
      label: 'Nearby Districts'
    }, extraOpts.subHeading));
    nearbyDistricts.forEach(district => {
      options.push({
        label: extraOpts.addState ? getLocalityName(district) : district.name,
        value: localityToSlug(district),
        indented: true
      });
    });
  }
  return options;
};
class RegionSelector extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onSelect", localitySlug => {
      this.setState(prevState => {
        var localities = localitySlugToFilter(localitySlug);
        var filters = prevState.filters.cloneWith({
          localities
        });
        return {
          filters
        };
      }, () => {
        if (this.dropdownRef && this.dropdownRef.ensureClosed) {
          this.dropdownRef.ensureClosed();
        }
        this.props.onSubmitFilter(this.state.filters);
      });
    });
    _defineProperty(this, "setDropdownRef", ref => {
      this.dropdownRef = ref;
    });
    this.state = {
      filters: new Filters(this.props.listingType, this.props.filters)
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var filters = new Filters(nextProps.listingType, nextProps.filters);
    if (!isEqual(this.props.filters.getValues(), filters.getValues())) {
      this.setState({
        filters
      });
    }
  }
  render() {
    var _this$props$media = this.props.media,
      mobile = _this$props$media.mobile,
      tablet = _this$props$media.tablet,
      desktop = _this$props$media.desktop;
    var selectedLocalitySlug = localityToSlug(this.props.singleLocality);
    var selectedLocalityName = getLocalityName(this.props.singleLocality);
    var options = regionGroupToOptions(this.props.regionGroup);
    return ___EmotionJSX("span", {
      css: styles.regionSelector(options.findIndex(option => option.label === 'Nearby Districts'))
    }, ___EmotionJSX(PinIcon, {
      size: "small",
      css: styles.regionIcon
    }), mobile && ___EmotionJSX(Select, {
      label: "region-selector",
      options: regionGroupToOptions(this.props.regionGroup, {
        subHeading: {
          disabled: true,
          value: 'NOVALUE-0'
        },
        addState: true
      }),
      value: selectedLocalitySlug,
      onChange: _ref3 => {
        var value = _ref3.value;
        this.onSelect(value);
      },
      labelHidden: true
    }), (tablet || desktop) && ___EmotionJSX(Dropdown, {
      css: dropdownStyles.dropdown,
      align: "centre",
      ref: this.setDropdownRef,
      title: selectedLocalityName,
      anchorClass: "allhomes-dropdown-anchor"
    }, ___EmotionJSX(Selector, {
      options: options,
      selectedValue: selectedLocalitySlug,
      onSelect: this.onSelect
    })));
  }
}
RegionSelector.propTypes = {
  regionGroup: regionGroupPropTypes.isRequired,
  listingType: PropTypes.string.isRequired,
  singleLocality: localityPropTypes.isRequired,
  filters: PropTypes.instanceOf(Filters),
  media: PropTypes.objectOf(PropTypes.bool),
  onSubmitFilter: PropTypes.func
};
RegionSelector.defaultProps = {
  filters: {},
  media: {},
  onSubmitFilter: () => {}
};
export default withMedia(RegionSelector);